import avatar from  '../assets/images/bira-carvalho/bira-carvalho-perfil.jpg';
import audio from '../assets/sounds/bira-carvalho.ogg';

import bira01 from '../assets/images/bira-carvalho/BiraCarvalho_02.jpg';
import bira02 from '../assets/images/bira-carvalho/BiraCarvalho_03.jpg';
import bira03 from '../assets/images/bira-carvalho/BiraCarvalho_04.jpg';
import bira04 from '../assets/images/bira-carvalho/06biracarvalho0012_edited.jpg';
import bira05 from '../assets/images/bira-carvalho/jbira_pasiata_449.jpg';

const biraData = {
    avatar,
    audio,
    bira01,
    bira02,
    bira03,
    bira04,
    bira05
}

export default biraData